import * as React from 'react'
import { RouteComponentProps } from 'react-router-dom'
import { inject, observer } from 'mobx-react'
import { Modal as AntdModal } from 'antd'
import Modal from 'react-responsive-modal'
import { findLast, get as _get } from 'lodash'
import RouteWrapper from 'components/HOC/RouteWrapper'
import { checkType, getWelcomeInfo } from 'constants/index'
import { ComponentExt } from 'util/reactExt'
import { withPopover } from 'components/HOC/AntdWrapper'
import Url from 'util/url'
import CheckPanel from 'containers/views/Levelup/CheckPanel'
import Bubble from 'components/Bubble'
import PlayIcon from 'components/PlayIcon'
import Audio from 'components/Audio'
import { routeMap } from 'constants/routes'
import CheckGroupBoard from 'containers/views/Levelup/CheckGroupBoard'
import styles from './index.scss'
import letter from 'assets/check/letter.png'
import vicotoryIcon from 'assets/check/victory-window.svg'
import passIcon from 'assets/check/pass-window.svg'
import loseVoice from 'assets/audio/lose.mp3'
import selectVoice from 'assets/audio/select.mp3'
import successVoice from 'assets/audio/success.mp3'
const bgVoice = '//ss.yidejia.com/xy-front/dist/qa/static/fonts/bg.1af28d1.mp3'

const PER_PAGE = 100

// 根据员工姓名个数选择字体大小
const fontSizeOfStaffName = {
  '*': 16,
  5: 18,
  4: 20,
  3: 22,
  2: 22,
  1: 22,
}

interface ILevelModeProps extends RouteComponentProps {
  globalStore?: any
  levelStore?: any
}

interface ILevelModeState {
  move?: string
  visible: boolean
  currentCheckGroupIndex: number // 当前关卡分组 index
  leftBtnMode: string
  rightBtnMode: string
  currentLessonId: number
  checkPanelVisible: boolean
  passCheckVisible: boolean
  failCheckVisible: boolean
  testData: any
  currentHoverIndex: number
  checkHoverId: number
  currentAudioSrc: string
  groupPosition: number
  acitveGroupId: string
  filter: any
}

@inject('globalStore', 'levelStore')
@observer
class LevelMode extends ComponentExt<ILevelModeProps, ILevelModeState> {
  state = {
    visible: false,
    currentCheckGroupIndex: 0,
    leftBtnMode: '<:up',
    rightBtnMode: '>:up',
    currentLessonId: 0,
    checkPanelVisible: false,
    passCheckVisible: false,
    failCheckVisible: false,
    testData: null,
    currentHoverIndex: -1,
    checkHoverId: -1,
    currentAudioSrc: '',
    groupPosition: 0,
    acitveGroupId: '',
    filter: {
      per_page: PER_PAGE,
      page: 1,
    },
  }

  private checkGroupBoardRef = null

  constructor(props) {
    super(props)
    this.api.level.getUserLessons()
    this.api.level.getUserCheckRecord()
  }

  async componentDidMount() {
    const {
      levelStore: { getUserLessons, getUserCheckRecord },
    } = this.props

    await getUserLessons()
    const defaultLesson =
      findLast(
        this.props.levelStore.userLessons,
        lesson => !lesson.is_locked,
      ) || {}

    await getUserCheckRecord({
      ...this.filter,
      lesson_id: defaultLesson.id,
    })

    const {
      levelStore: {
        userCheckRecord: { meta },
      },
    } = this.props

    this.setState({
      visible: meta.is_first_visit ? true : false,
      currentLessonId: defaultLesson.id,
    })
  }

  onRef = ref => (this.checkGroupBoardRef = ref)

  get query(): any {
    const {
      location: { search },
    } = this.props
    const query: any = new Url(search).query()
    return query
  }

  get filter(): any {
    return {
      per_page: PER_PAGE,
      page: 1,
      lesson_id: this.state.currentLessonId,
      group_id: this.state.acitveGroupId,
    }
  }

  get isLastCheck(): any {
    const {
      levelStore: {
        userCheckRecord: { data },
        currentUserCheck,
      },
    } = this.props

    return (
      currentUserCheck &&
      currentUserCheck.grade === data.length &&
      !this.state.acitveGroupId
    )
  }

  switchLesson = async (lesson: any): Promise<any> => {
    const { history, match } = this.props
    const url = `${match.url}?role=${lesson.path}`
    this.setState(
      {
        currentLessonId: lesson.id,
        groupPosition: 0,
        acitveGroupId: '',
      },
      async (): Promise<any> => {
        const {
          levelStore: { getUserCheckRecord },
        } = this.props
        await getUserCheckRecord(this.filter)
        history.push(url)
      },
    )
  }

  renderLessonComponent = (): React.ReactElement<any> => {
    const {
      levelStore: { userLessons },
    } = this.props
    const { currentLessonId, currentHoverIndex } = this.state

    return (
      <ol className={styles.lessons}>
        {userLessons.map((lesson, index) => {
          const isCurrentHoverIndex = currentHoverIndex === index
          return (
            <li key={lesson.id} className={styles.lessonWrapper}>
              <div
                className={`${styles.lesson} ${
                  lesson.id === currentLessonId ? styles.active : ''
                }`}
                onMouseEnter={this.toggleHoverIndex.bind(this, index)}
                onMouseLeave={this.toggleHoverIndex.bind(this, -1)}
                onClick={
                  !lesson.is_locked
                    ? this.switchLesson.bind(this, lesson)
                    : null
                }
              >
                <span className={styles.lessonName}>{lesson.name}</span>
              </div>
              {index !== userLessons.length - 1 && (
                <div className={styles.lessonArrow} />
              )}
              {lesson.is_locked && (
                <Bubble
                  style={{
                    width: 176,
                    height: 87,
                    position: 'absolute',
                    top: -96,
                    left: 30,
                    color: '#85574E',
                    fontSize: 14,
                    textAlign: 'center',
                    lineHeight: '80px',
                    visibility: isCurrentHoverIndex ? 'visible' : 'hidden',
                    opacity: isCurrentHoverIndex ? 1 : 0,
                    transition: 'all 1s cubic-bezier(0.19, 1, 0.22, 1)',
                  }}
                >
                  您未符合该等级课程
                </Bubble>
              )}
            </li>
          )
        })}
      </ol>
    )
  }

  toggleHoverIndex = index => {
    if (index === 0) {
      return
    }
    this.setState({
      currentHoverIndex: index,
    })
  }

  fetchTestData = async id => {
    const testData = await this.api.level.getCheckTaskRecordDetail(id)
    this.setState({
      testData,
    })
  }

  openCheckPanelModal = async (check: any): Promise<any> => {
    const {
      levelStore: {
        setCurrentUserCheck,
        toggleAudioVoice,
        fetchCheckTaskRecords,
      },
    } = this.props
    // tslint:disable
    const self = this
    if (!check.is_locked) {
      toggleAudioVoice({
        src: selectVoice,
      })

      // 替换掉原有的数据加载方式,优化数据获取速度

      const checkdata = await fetchCheckTaskRecords(check.id)
      self.setState({
        checkPanelVisible: true,
      })

      if (
        check.check.type === checkType.exam ||
        check.check.type === checkType.example
      ) {
        const check_task = _get(checkdata, 'check_task_records[0]')
        await this.fetchTestData(check_task.id)
      }
      setCurrentUserCheck(checkdata)

      /*setTimeout(() => {
        self.setState({
          checkPanelVisible: true,
        })

      }, 300)*/
      return
    }
  }

  onCloseCheckPanelModal = () => {
    const {
      levelStore: { setCurrentUserCheck, toggleAudioVoice, getUserCheckRecord },
    } = this.props
    getUserCheckRecord(this.filter)
    this.setState({ checkPanelVisible: false })
    toggleAudioVoice({ src: '' })
    setCurrentUserCheck(null)
  }

  onOpenPassCheckModal = () => {
    const {
      levelStore: { toggleAudioVoice },
    } = this.props
    toggleAudioVoice({
      src: successVoice,
      loop: false,
    })
    this.setState({
      passCheckVisible: true,
      checkPanelVisible: false,
    })
  }

  onToggleFailCheckModal = (mode: boolean) => {
    const {
      levelStore: { toggleAudioVoice },
    } = this.props
    this.setState({
      failCheckVisible: mode,
      checkPanelVisible: false,
    })
    toggleAudioVoice({
      src: mode ? loseVoice : '',
    })
  }

  onTogglePassCheckModal = async (mode: boolean): Promise<any> => {
    const {
      levelStore: { getUserCheckRecord, toggleAudioVoice },
    } = this.props

    if (!mode) {
      await getUserCheckRecord(this.filter)
    }

    this.setState({
      passCheckVisible: mode,
      checkPanelVisible: false,
    })
    toggleAudioVoice({
      src: mode ? successVoice : '',
    })
  }

  get groupBarWrapperWidth() {
    const {
      levelStore: {
        userCheckRecord: {
          meta: { check_template },
        },
      },
    } = this.props
    const numOfCheckGroups =
      check_template && check_template.check_groups
        ? check_template.check_groups.length
        : 0
    return numOfCheckGroups * 104 + (numOfCheckGroups - 1) * 100
  }

  setActiveGroup = async (index, id): Promise<any> => {
    const {
      levelStore: { getUserCheckRecord },
    } = this.props

    this.setState(
      {
        acitveGroupId: index < 0 ? '' : id,
      },
      () => {
        this.checkGroupBoardRef.setCurrentCheckGroup(0)
        if (index > -1) {
          getUserCheckRecord(this.filter)
        } else {
          delete this.filter.group_id
          getUserCheckRecord(this.filter)
        }
      },
    )
  }

  renderCheckGroupComponent = () => {
    const {
      levelStore: {
        userCheckRecord: {
          meta: { check_template },
        },
      },
    } = this.props

    const { groupPosition, acitveGroupId } = this.state
    const check_groups =
      check_template && check_template.check_groups
        ? check_template.check_groups
        : []

    return (
      <ul className={styles.checkGroup}>
        {check_groups && check_groups.length > 4 && (
          <li
            className={`${styles.groupItem} ${styles.groupBtn} ${styles.groupPrevBtn}`}
            onClick={this.moveCheckGroup.bind(this, -1)}
          />
        )}

        <li className={`${styles.groupItem} ${styles.groupBarWrapper}`}>
          <div
            style={{
              position: 'relative',
              left: groupPosition,
              transition: 'all .6s',
              width: this.groupBarWrapperWidth,
            }}
          >
            {check_groups &&
              check_groups.map((item, index) => {
                return withPopover({
                  content: item.name,
                  placement: 'top',
                  overlayClassName: 'group-item-popover',
                })(
                  <a
                    key={item.id}
                    onClick={this.setActiveGroup.bind(
                      this,
                      acitveGroupId === item.id ? -1 : index,
                      item.id,
                    )}
                    className={`${styles.groupItemBtn} ${
                      acitveGroupId === item.id ? styles.active : ''
                    }`}
                  >
                    {item.name && item.name.slice(0, 4)}
                  </a>,
                )
              })}
          </div>
        </li>
        {check_groups && check_groups.length > 4 && (
          <li
            className={`${styles.groupItem} ${styles.groupBtn} ${styles.groupNextBtn}`}
            onClick={this.moveCheckGroup.bind(this, 1)}
          />
        )}
      </ul>
    )
  }

  moveCheckGroup = (moveNum: number): void => {
    let { groupPosition } = this.state
    const btnWidth = 104
    const btnMarginRight = 100
    groupPosition = groupPosition + -1 * moveNum * (btnWidth + btnMarginRight)

    if (groupPosition >= 0) {
      groupPosition = 0
    } else if (groupPosition <= -this.groupBarWrapperWidth) {
      groupPosition = -this.groupBarWrapperWidth + btnWidth
    }

    this.setState({
      groupPosition,
    })
  }

  toggleLetter = (mode: boolean): void => {
    this.setState({
      visible: mode,
    })
  }

  toggleAudioVoice = () => {
    const {
      levelStore: {
        bgAudioConfig: { src },
        toggleAudioVoice,
      },
    } = this.props
    if (src === bgVoice) {
      toggleAudioVoice(
        {
          src: '',
        },
        'bg',
      )
    } else {
      toggleAudioVoice(
        {
          src: bgVoice,
        },
        'bg',
      )
    }
  }

  get welcomeInfo() {
    const {
      globalStore: { staffInfo },
    } = this.props
    const lesson = findLast(
      this.props.levelStore.userLessons,
      lesson => !lesson.is_locked,
    )
    const htmlArr = lesson
      ? getWelcomeInfo({
          name: staffInfo.staff_name,
          type: lesson.target_staff,
        })
          .map(item => {
            const [tag, content] = item
            return `<${tag}>${content}</${tag}>`
          })
          .join('')
      : []

    return htmlArr
  }

  render() {
    const {
      checkPanelVisible,
      passCheckVisible,
      failCheckVisible,
      acitveGroupId,
      testData,
    } = this.state
    const {
      levelStore: {
        currentUserCheck,
        audioConfig,
        bgAudioConfig,
        userCheckRecord,
      },
      globalStore: { staffInfo },
    } = this.props
    const isPlay = bgAudioConfig.src === bgVoice ? true : false
    return (
      <div className={styles.levelMode}>
        <section className={styles.lessonsWrapper}>
          {this.renderLessonComponent()}
        </section>
        <section className={'letter-wrapper'}>
          <AntdModal
            wrapClassName={'letter-wrapper'}
            closable={false}
            style={{
              background: 'transparent',
            }}
            bodyStyle={{
              backgroundImage: `url(${letter})`,
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'contain',
              height: 685,
              backgroundPosition: 'center',
            }}
            visible={this.state.visible}
            footer={null}
            onOk={this.toggleLetter.bind(this, true)}
          >
            <div
              className={styles.letterName}
              style={{
                fontSize:
                  fontSizeOfStaffName[
                    staffInfo.staff_name && staffInfo.staff_name.length
                  ] || fontSizeOfStaffName['*'],
              }}
              dangerouslySetInnerHTML={{ __html: this.welcomeInfo }}
            />
            <div
              className={styles.letterBtn}
              onClick={this.toggleLetter.bind(this, false)}
            >
              开启闯关
            </div>
          </AntdModal>
        </section>
        <section>{this.renderCheckGroupComponent()}</section>
        <section className={styles.checksWrapper}>
          {userCheckRecord && (
            <CheckGroupBoard
              useShadow={true}
              openCheckPanelModal={this.openCheckPanelModal}
              onRef={this.onRef}
              acitveGroupId={acitveGroupId}
            />
          )}
        </section>
        <section>
          {/* 答题面板 */}
          <Modal
            closeOnOverlayClick={false}
            showCloseIcon={false}
            classNames={{
              overlay: styles.modalOverlay,
              modal: styles.customModal,
            }}
            focusTrapped={false}
            open={checkPanelVisible}
            onClose={this.onCloseCheckPanelModal}
            center
          >
            {currentUserCheck && (
              <CheckPanel
                testData={testData}
                check={currentUserCheck}
                onCloseCheckPanelModal={this.onCloseCheckPanelModal}
                onOpenPassCheckModal={this.onOpenPassCheckModal}
                onOpenFailCheckModal={this.onToggleFailCheckModal.bind(
                  this,
                  true,
                )}
              />
            )}
          </Modal>
          {/*答题通通过面板*/}
          <Modal
            closeOnOverlayClick={false}
            showCloseIcon={false}
            classNames={{
              overlay: styles.modalOverlay,
              modal: styles.plainModal,
            }}
            open={passCheckVisible}
            focusTrapped={false}
            onClose={this.onCloseCheckPanelModal}
            center
          >
            <div
              className={styles.passWindow}
              style={{
                backgroundImage: `url(${
                  this.isLastCheck ? vicotoryIcon : passIcon
                })`,
              }}
            />
            {this.isLastCheck ? (
              <>
                <p className={styles.resultText}>
                  恭喜，您已完成"新人进阶"所有挑战！
                </p>
                <p className={styles.resultDesc}>敬请期待下一个等级的开启：</p>
                <p className={styles.resultDesc}>1. 完成"组长进阶"所有挑战</p>
                <p className={styles.resultDesc}>2. 通过试用期转正考核</p>
              </>
            ) : (
              <>
                <p className={styles.resultText}>恭喜，你已顺利通过本关</p>
                <p className={styles.resultDesc}>即将开启下一关卡</p>
              </>
            )}
            <a
              className={styles.confirmBtn}
              onClick={this.onTogglePassCheckModal.bind(this, false)}
            >
              确定
            </a>
          </Modal>
          {/*答题失败面板*/}
          <Modal
            closeOnOverlayClick={false}
            showCloseIcon={false}
            classNames={{
              overlay: styles.modalOverlay,
              modal: styles.customModal,
            }}
            open={failCheckVisible}
            onClose={this.onCloseCheckPanelModal}
            focusTrapped={false}
            center
          >
            {
              <CheckPanel
                testData={testData}
                check={currentUserCheck}
                onCloseCheckPanelModal={this.onCloseCheckPanelModal}
                onOpenPassCheckModal={this.onOpenPassCheckModal}
                onOpenFailCheckModal={this.onToggleFailCheckModal.bind(
                  this,
                  true,
                )}
              />
            }
          </Modal>
        </section>
        <section className={styles.music}>
          <PlayIcon isPlay={isPlay} toggleAudioVoice={this.toggleAudioVoice} />
        </section>
        <section className={'music'}>
          <Audio {...bgAudioConfig} />
          <Audio {...audioConfig} />
        </section>
      </div>
    )
  }
}

export default RouteWrapper(routeMap.LEVEL_UP.LEVEL_MODE.path)(LevelMode)
